
export enum DescripcionConcepto
{
    Devolucion, 
    Reexpedicion
}

export enum CondicionPago
{
    Pagada,
    Pendiente
}

export interface PartidaAclaracion
{
    IdRegistro: number;
    IdSucursal: number;
    Folio: string;
    FechaCreacion: Date;
    FechaAlDia: Date;
    Guias: PartidaAclaracionGuiaDTO[];
    Facturas: PartidaAclaracionFacturaDTO[];
    Depositos: PartidaAclaracionDepositoDTO[];
}

export interface PartidaAclaracionDTO extends PartidaAclaracion
{
    CantidadGuias: number;
    CantidadFacturas: number;
    CantidadDepositos: number;
    Total: number;
    CondicionNombre: string;
    DescripcionNombre: string;
}

export interface PartidaAclaracionGuia
{
    IdPartidaAclaracion: number;
    IdGuia: number;
    Observaciones: string;
    Condicion: CondicionPago;
    DescripcionConcepto: DescripcionConcepto;
}

export interface PartidaAclaracionGuiaDTO extends PartidaAclaracionGuia
{
    FolioGuia: string;
    Total: number;
    CondicionNombre: string;
    DescripcionNombre: string;
}

export interface TotalPartidaAclaracionConcepto
{
    Total: number;
}

export interface PartidaAclaracionFactura
{
    IdPartidaAclaracion: number;
    IdFactura: number;
    Observaciones: string;
    Condicion: CondicionPago;
    DescripcionConcepto: DescripcionConcepto;
}

export interface PartidaAclaracionFacturaDTO extends PartidaAclaracionFactura
{
    Serie: string;
    Folio: number;
    Total: number;
    CondicionNombre: string;
    DescripcionNombre: string;
}

export interface PartidaAclaracionDeposito
{
    IdPartidaAclaracion: number;
    IdDeposito: number;
    Observaciones: string;
    Condicion: CondicionPago;
    DescripcionConcepto: DescripcionConcepto;
}

export interface PartidaAclaracionDepositoDTO extends PartidaAclaracionDeposito
{
    SerieFolio: string;
    Total: number;
    CondicionNombre: string;
    DescripcionNombre: string;
}

export interface FiltroPartidasAclaracion
{
    Folio?: number | null;
    FechaDesde?: Date | null;
    FechaHasta?: Date | null;
    TotalDesde?: number | null;
    TotalHasta?: number | null;
}


// WEBPACK FOOTER //
// ./app/models/partidaaclaracion.ts